<template>
  <div @click="hideMe" class="menu-overlay has-background-primary is-vertical-center" v-show="visible">
    <div class="has-text-centered is-fullwidth is-size-3 has-text-white">
      <div class="is-inline-block m-r-lg">
      <p @click="go(0)">{{ 'Name' | translate }}</p>
      <p @click="go(1)">{{ 'Sex' | translate }}</p>
      <p @click="go(2)">{{ 'Age' | translate }}</p>
      <p @click="go(3)">{{ 'Height' | translate }}</p>
      </div><div class="is-inline-block">
      <p @click="go(4)">{{ 'Weight' | translate }}</p>
      <p @click="go(5)">{{ 'Body' | translate }}</p>
      <p @click="go(6)">{{ 'Goal' | translate }}</p>
      </div>
    </div>
    <div class="close-icon">
      <img src="@/../static/svg/cancel-white.svg" class="is-medium icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuProfile',
  props: ['show'],
  data () {
    return {
      visible: this.show
    }
  },
  methods: {
    showMe() {
      this.visible = true
    }, 
    hideMe() {
      this.visible = false
    },
    go(n) {
      this.$emit('go', n)
    }
  }
}
</script>

<style>
.menu-overlay {
  position:fixed;
  top:0;
  right:0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.close-icon {
  opacity:0.7;
  position:absolute;
  top:1rem;
  right:0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/ProfileMenu.vue